import { INPUT_TEXT_DISPLAY_NAME } from "./core";
import createTestId from "../../../fabrics/createTestId";

export const createTestIdForInputTextElement = createTestId(
    INPUT_TEXT_DISPLAY_NAME,
);
